import { render, staticRenderFns } from "./dividerBlock.vue?vue&type=template&id=96274a88&scoped=true"
import script from "./dividerBlock.vue?vue&type=script&lang=js"
export * from "./dividerBlock.vue?vue&type=script&lang=js"
import style0 from "./dividerBlock.vue?vue&type=style&index=0&id=96274a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96274a88",
  null
  
)

export default component.exports